import React, { Component } from 'react';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import parkData from '../../assets/location/loc.json';
import { Icon } from "leaflet";

const LocPinIcon = new Icon({
    iconUrl: require("../../assets/location/pin.svg"),
    // iconRetinaUrl: require("../../assets/location/pin.svg"),
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    // iconAnchor: null,
    // popupAnchor: null,
    // shadowUrl: null,
    // shadowSize: null,
    // shadowAnchor: null,
    iconSize: [35, 35],
    // className: 'leaflet-div-icon'
});

class MapWidget extends Component {
    constructor() {
        super()
        this.state = {
            lat_lng: parkData.data.cities.loc,
            city_names: parkData.data.cities.names,
            zoom: parkData.data.zoom,
            location_index: 0,
        }
    }

    handleLocation = (location_index) => {
        this.setState({
            location_index,
        })
    }


    render() {
        const { location_index, lat_lng, zoom, city_names } = this.state;
        console.log(parkData)
        return (
            <div style={{ width: "100%", height: "100%" }}>
                <Map
                    center={lat_lng[location_index]} 
                    zoom={zoom} 
                    style={{ width: "100%", height: "100%" }}
                    attributionControl={false}
                >
                    {/* LOCATION SELECTOR */}
                    <div class="btn-group" role="group" style={{ zIndex: "400" }}>
                        <button id="btnGroupDropLoc" className="btn btn-light btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <b>View offices</b>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDropLoc">
                            <p className="dropdown-item" onClick={() => this.handleLocation(0)}>{city_names[0]}</p>
                            <p className="dropdown-item" onClick={() => this.handleLocation(1)}>{city_names[1]}</p>
                            <p className="dropdown-item" onClick={() => this.handleLocation(2)}>{city_names[2]}</p>
                        </div>
                    </div>

                    {/* MARKERS */}
                    {parkData.data.features.map(park => (
                        <Marker
                            icon={LocPinIcon}
                            key={park.properties.PARK_ID}
                            position={[
                                park.geometry.coordinates[0],
                                park.geometry.coordinates[1]
                            ]}
                        >
                            <Popup>
                                {park.properties.NAME}
                            </Popup>
                        </Marker>
                    ))}

                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    // attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    />
                </Map>
            </div>
        );
    }
}

export default MapWidget;